module.exports = __webpack_public_path__ + "img/img (12).1d41a624.jpg";